import React from 'react'
// import { CSSTransition } from 'react-transition-group'
import PropTypes from 'prop-types'
import WithBodyScrollLock from '../../../hoc/with_body_scroll_lock.tsx'

const propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func
}

@WithBodyScrollLock
class BaseModal extends React.Component {
  componentDidUpdate() {
    if (this.refs.modalOverlay && !this.refs.modalOverlay.onclick) {
      // 点击阴影背景时cancel() popup
      this.refs.modalOverlay.onclick = e => {
        e.stopPropagation()
        this.props.onCancel && this.props.onCancel()
      }

      // 点击modal阻止默认行为
      // 原理：react event listener中无法阻止原生事件，所以用原生事件来替代react事件
      this.refs.modal.onclick = e => e.stopPropagation()
    }
  }

  onModalRefChange = modalRef => {
    const { bodyScrollLock } = this.props
    bodyScrollLock.onLockTargetElementRefChange(modalRef)
    this.modal = modalRef
  }

  render() {
    let modal = <span />
    if (this.props.visible) {
      modal = (
        <div
          className="modal-overlay"
          ref={modalOverlay => {
            this.modalOverlay = modalOverlay
          }}
        >
          <div className="modal" ref={this.onModalRefChange}>
            {this.props.children}
          </div>
        </div>
      )
    }
    return (
      // <CSSTransition classNames="modal-transition" timeout={240} in={true}>
      modal
      // </CSSTransition>
    )
  }
}

BaseModal.propTypes = propTypes

export default BaseModal
